/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';

class SocialAvatarTab extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let avatar = null,
            ServiceIcon = null,
            serviceName = '',
            tabClass = 'network-tab',
            avatarClass = 'avatar-wrapper';

        if (this.props.social.icon) {
			avatar = <div className="avatar-bg"><img src={this.props.social.icon} className="avatar-img"/></div>;
		} else {
			avatar = <div className="avatar-bg"><i className="fa fa-user"></i></div>;
            avatarClass += ' default'
		}

        if (this.props.social.psID) {
            if (!(ServiceIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.social.psID)])) {
    			ServiceIcon = IconFactory.generic;
    		} else {
                serviceName = ConstantMixin.getIconIndexByCode(this.props.social.psID);
                tabClass += ' ' + serviceName;
                avatarClass += ' ' + serviceName;
            }
        }

        if (this.props.inactive) {
            tabClass += ' inactive';
            avatarClass += ' inactive';
        }

        return (
            <div className="tabbed-social-avatar">
                <div className={tabClass}>
                    <ServiceIcon bare={true} white={true}/>
                </div>
                <div className={avatarClass}>
                    <div className="social-avatar">
                        {avatar}
                    </div>
                </div>
            </div>
        );
    }

};

SocialAvatarTab.propTypes = {
    social: PropTypes.object,
    wrapperClass: PropTypes.string,
    inactive: PropTypes.bool,
};

SocialAvatarTab.defaultProps = {
    social: null,
    wrapperClass: '',
    inactive: false,
};

export default SocialAvatarTab;
